import { createFileRoute } from '@tanstack/react-router'
import { ProductLabelsPage } from '../../../../features/catalog/product-labels-page'
import { productLabelsSearchSchema } from '../../../../features/catalog/search'

export const Route = createFileRoute('/_app/products/$productId/labels')({
  staticData: { crumb: 'productLabels' },
  validateSearch: productLabelsSearchSchema,
  component: ProductLabelsPage,
})
